import React, { createContext, useContext, useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const CmsContext = createContext(null);

export function CmsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [pages, setPages] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      fetch(`${API}/api/cms/settings`).then(r => r.json()).catch(() => null),
    ]).then(([settingsData]) => {
      if (settingsData) setSettings(settingsData);
      setLoading(false);
    });
  }, []);

  const fetchPage = async (pageKey) => {
    if (pages[pageKey]) return pages[pageKey];
    try {
      const res = await fetch(`${API}/api/cms/pages/${pageKey}`);
      const data = await res.json();
      setPages(prev => ({ ...prev, [pageKey]: data }));
      return data;
    } catch {
      return null;
    }
  };

  const refreshSettings = async () => {
    try {
      const res = await fetch(`${API}/api/cms/settings`);
      const data = await res.json();
      setSettings(data);
    } catch {}
  };

  return (
    <CmsContext.Provider value={{ settings, pages, loading, fetchPage, refreshSettings }}>
      {children}
    </CmsContext.Provider>
  );
}

export function useCms() {
  return useContext(CmsContext);
}

export function usePage(pageKey) {
  const { pages, fetchPage } = useCms();
  const [pageData, setPageData] = useState(pages[pageKey] || null);
  const [loading, setLoading] = useState(!pages[pageKey]);

  useEffect(() => {
    if (!pages[pageKey]) {
      fetchPage(pageKey).then(data => {
        setPageData(data);
        setLoading(false);
      });
    } else {
      setPageData(pages[pageKey]);
      setLoading(false);
    }
  }, [pageKey, pages, fetchPage]);

  return { data: pageData, loading };
}
